import React from 'react';
import './Services.css';

const Services = () => {
  const telehealthBenefits = [
    "Convenience – Attend sessions from the comfort of your home, office, or any private space.",
    "Flexibility – Easier scheduling with no commute time.",
    "Accessibility – Ideal for individuals in rural areas or with limited mobility.",
    "Comfort – Many people feel more at ease opening up in familiar environments.",
    "Continuity of care – Stay connected even when traveling or during life transitions."
  ];

  return (
    <div className="services">
      <div className="services-container">
        <div className="services-header">
          <h1>Services</h1>
          <p className="lgbtq-ally">
            <span className="rainbow-text">LGBTQ+ Allied provider</span>
          </p>
        </div>
        
        <div className="services-content">
          <div className="service-section">
            <h2>Individual Therapy</h2>
            <p>
              I provide individual counseling in a safe, supportive, and affirming space for adults 
              of all backgrounds, identities, and life experiences.
            </p>
          </div>

          <div className="service-section">
            <h2>Group Therapy</h2>
            <p>
              I offer a 6-week psychoeducational grief group designed to support adults navigating loss. 
              Each session is 1 hour and includes education, guided reflection, and space for shared 
              experience in a supportive environment.
            </p>
            <p>
              I am available to lead these groups for churches, organizations, and businesses. 
              Sessions can be held virtually or on-site, depending on your needs.
            </p>
            <p>
              If you're interested in bringing a grief group to your community or workplace, 
              please contact me directly for more information and availability.
            </p>
          </div>

          <div className="service-section">
            <h2>Virtual Appointments Only</h2>
            <p>
              I currently do not provide in-person appointments. I provide virtual counseling services 
              exclusively, making therapy more accessible and flexible for your lifestyle.
            </p>
            <p>Benefits of telehealth include:</p>
            <ul className="benefits-list">
              {telehealthBenefits.map((benefit, index) => (
                <li key={index}>{benefit}</li>
              ))}
            </ul>
            <p>
              All you need is a private space, a stable internet connection, and a phone, tablet, or computer.
            </p>
          </div>

          <div className="service-section">
            <h2>Rates & Insurance</h2>
            <div className="rates-info">
              <p><strong>My rate is $125 per session.</strong></p>
              <p>
                I do offer lower rates based on sliding fee scales to clients that qualify and if I have availability.
              </p>
              <p>
                I do accept a few insurance plans. Please reach out to me directly to determine if I'm on your plan.
              </p>
            </div>
          </div>

          <div className="service-section">
            <h2>Cancellation Policy</h2>
            <div className="cancellation-info">
              <p>
                If you need to cancel or reschedule your appointment, please provide at least 24 hours' notice.
              </p>
              <p>
                Cancellations made with less than 24 hours' notice—or missed appointments—may be subject to the full session fee.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
